module.exports = __webpack_public_path__ + "ca38fbecd958c12c4b9d8a757e550073.pdf";